import { Component } from '@angular/core';

@Component({
  //selector: 'dialog-content-example-dialog',
  selector: 'needs-kit-modal',
  templateUrl: 'needsVenous.modal.html',
})
export class NeedsVenousModal { }
